import { Box } from '@qga/roo-ui/components';

import withProps from '@/components/withProps';

const Section = withProps({
  maxWidth: '830px',
  width: '100%',
})(Box);

export default Section;
